<template>
  <div id="app">
    <aurealHeader></aurealHeader>
      <router-view></router-view>
      <!-- <notificationModal 
         v-if="notificatioModalVisible"
        container= "CONT-AAAA-123"
        :text= messageContainer
        user= "Consignatario 1"
        :date= fecha
        color= "#870091">
      </notificationModal> -->
      <confirmModal v-if="modalVisible" :message=messageContainer link="/containers"></confirmModal>
      <notificationModal 
        v-if="notification.visible" 
        v-bind:key="notification.container"
        v-bind:container="notification.container"
        v-bind:text="notification.text"
        v-bind:user="notification.user"
        v-bind:date="notification.date"
        v-bind:color="notification.color"
      ></notificationModal>
    <div class="mt-5"></div>
    <aurealFooter></aurealFooter>
  </div>
</template>

<script>
import aurealFooter from '@/components/footer'
import aurealHeader from '@/components/header'
import * as localData from '@/services/localData.js'
import confirmModal from '@/components/confirmModal'
import notificationModal from '@/components/notificationModal'
import { mapGetters } from 'vuex'

import {getSensorGeneral,getSensorSensing,putSensorData} from '@/services/api'
import {timestampToDate} from '@/services/helper'
import {putAlertData,getAlertData} from '@/services/api'


const socket = window.io.connect(`https://watcher.m2msystemsource.com/HJexeDXfII`)
socket.on('connect', () => console.log('io-connect success'))
socket.on('connect_error', () => console.log('ERROR io-connect'))

// Recibir datos
socket.on('greetings', (data) => console.log('new greetings', data))
//socket.on('sensing', (data) => console.log('new sensing', data))


export default {
  name: 'App',
  components: {
    aurealFooter,
    aurealHeader,
    confirmModal,
    notificationModal
  },
   data() {
    return {
        messageContainer: '',
        fecha: '',
        modalVisible: false,
        notificationModalVisible: false,
        containerName: ''
    }
  },
  computed: { 
    ...mapGetters(['notificatioModalVisible']),
    ...mapGetters(['notification']),
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
    }),
    ...mapGetters("container",{
      alert_id: 'alert_id',
      alert_type: 'alert_type',
      container_id: 'container_id'
    }),
  },
  mounted () {
    if(this.isLoggedIn) 
    socket.on('alert', (data) => {
      console.log('new alert', data)
       if(this.isLoggedIn)  this.webSocketAlert(data)

    })
    // socket.on('alert-retry', (data) => {
    //   console.log('new alert-retry', data)
    //   if(this.isLoggedIn) this.webSocketAlert(data)

    // })
   //this.getSensor()
   //this.putSensorName('CONT-555-6854FG')
  },
  methods: { 
      getSensor (){
        getSensorGeneral('').then(res => {
           console.log(res.data)
         })
        //   getSensorSensing('?sort=gpstime:asc&limit=10').then(res => {
        //    console.log(res.data)
        //  })
         
      },
      putSensorName(name) {
        putSensorData('?customName='+name+'&vars={expediente:'+ this.container_id +'}').then(res => {
          console.log(res.data)
        })
      },
      webSocketAlert (data){
        this.fecha = timestampToDate(data.sensing.time)

        getSensorGeneral('?select=_id,sensing,name,color,customName,status,vars,group,version').then(res => {

          this.containerName = res.data.customName
          var setRead = {read:"true"}

          if(data.props.type == '_out'){
           // if(this.alert_id && this.alert_type =='_in') putAlertData(this.alert_id,setRead)
            this.messageContainer = 'ha salido del puerto' 

          }else if (data.props.type == '_in'){
           // if(this.alert_id && this.alert_type =='_out') putAlertData(this.alert_id,setRead)
            this.messageContainer = 'ha entrado en el puerto'

          }
          this.$store.commit('container/setAlert', [data._id,data.props.type])


          var notification = {
            visible: true,
            container: this.containerName,
            text: this.messageContainer,
            user: 'El transportista ',
            date: this.fecha,
            color: '#ff0000',
          }
          this.$store.dispatch('change_notification', notification)
         })
        //console.log('new alert-retry', data)
        // console.log(data._rule)
        // console.log(data.sensing)

        //this.$store.commit('set_notificatioModalVisible', true)
        // var params = "?populate=_rule"
        // getAlertData(data._id,params).then(res => {
        //     console.log(res.data)
        // })

        // var setRead = {read:"true"}
        // putAlertData(data._id,setRead).then(res => {
        //     console.log(res.data)
        // })
        //console.log(this.notificatioModalVisible)

      }
  }
}
</script>

<style lang= "scss" scoped>
#app{
  /* width:100%; 
  height:100%; 
  position:fixed; 
  left:0;
  top:0; */
}

</style>
